import { useContext } from "react";
import api from "../api/api";
import { AuthContext } from "../provider/auth/AuthContext";
import { AxiosResponse } from "axios";
import { PedidoResponseDTO } from "../api/ResponseProps";

export const pedidoService = {
    registerPedido: async (
        data: FormData,
        token?: string
    ): Promise<AxiosResponse<PedidoResponseDTO>> => {    
        return api.post<PedidoResponseDTO>(`/pedido`, data, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
    }, 

    getPedidos: async (idEmpresa: number, token: string) => {
        try {
            const response = await api.get(`/pedido`, {
                headers: {
                    Authorization: `Bearer ${token}`
                },
                params: {
                    idEmpresa,
                    categoria: "TODOS"
                }
            });
            return response.data;
        } catch (error: any) {
            if (error.response) {
                throw error.response.data;
            }
    
            // erro de rede ou inesperado
            throw {
                status: 500,
                message: "Erro inesperado",
            };
        }
    },

    cancelarPedido: async (idPedido: number, token: string) => {
        try {
            const response = await api.post(
                `/pedido/${idPedido}/cancelar`,
                null,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
    
            return response.data;
    
        } catch (error: any) {
            if (error.response) {
                throw error.response.data;
            }
    
            // erro de rede ou inesperado
            throw {
                status: 500,
                message: "Erro inesperado",
            };
        }
    },

    avancarEtapaPedido: async (idPedido: number, token: string) => {
        try {
            const response = await api.post(
                `/pedido/${idPedido}/etapas/avancar`,
                null,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
    
            return response.data;
    
        } catch (error: any) {
            if (error.response) {
                throw error.response.data;
            }
    
            // erro de rede ou inesperado
            throw {
                status: 500,
                message: "Erro inesperado",
            };
        }
    },

    getCoresPorStatus: (status: string) => {
        if (status === "CRIADO") {
            return {
                color: "#919191",
                backgroundColor: "#E8E8E8",
                borderColor: "#BFBFBF"
            }
        } else if (status === "EM PREPARACAO") {
            return {
                color: "#A65F00",
                backgroundColor: "#FEF9C2",
                borderColor: "#FFF085"
            }
        } else if (status === "AGUARDANDO RETIRADA") {
            return {
                color: "#C45800",
                backgroundColor: "#FCF27C",
                borderColor: "#FFF252"
            }
        } else if (status === "AGUARDANDO PAGAMENTO") {
            return {
                color: "#0007C4",
                backgroundColor: "#827CFC",
                borderColor: "#8585FF"
            }
        } else if (status === "EM ROTA DE ENTREGA") {
            return {
                color: "#CA3500",
                backgroundColor: "#FFD6A7",
                borderColor: "#CA3500"
            }
        } else if (status === "CONCLUIDO") {
            return {
                color: "#FFFFFF",
                backgroundColor: "#FF7A2A",
                borderColor: "#CA3500"
            }
        } else if (status === "CANCELADO") {
            return {
                color: "#DBDBDB",
                backgroundColor: "#737373",
                borderColor: "#4F4F4F"
            }
        } else {
            return {
                color: "#ffffff",
                backgroundColor: "#000000",
                borderColor: "#FFF085"
            }
        }
    },

    
};